/**
 * Currency conversion utilities for minor/major unit conversion.
 * Supports USD, GBP, EUR which all use 2 decimal places.
 */

export const CURRENCY_MULTIPLIER = 100 // USD, GBP, EUR use 2 decimals (cents/pence)

/**
 * Converts from major currency units (dollars/pounds) to minor units (cents/pence).
 * @param amount - Amount in major units (e.g., 12.48)
 * @returns Amount in minor units (e.g., 1248)
 */
export function toMinorUnits(amount: number): number {
  return Math.max(0, Math.round(amount * CURRENCY_MULTIPLIER))
}

/**
 * Converts from minor currency units (cents/pence) to major units (dollars/pounds).
 * Returns a fixed-precision string suitable for API calls.
 * @param minor - Amount in minor units (e.g., 1248)
 * @returns Amount in major units as string (e.g., "12.48")
 */
export function toMajorUnits(minor: number): string {
  return (minor / CURRENCY_MULTIPLIER).toFixed(2)
}

/** Whole dollars omit decimals; amounts with cents use two decimals. Thousands use commas. */
export function formatRegistrationDropdownPrice(price: number): string {
  if (!Number.isFinite(price)) return ''

  if (price === Math.trunc(price)) {
    return price.toLocaleString('en-US', { maximumFractionDigits: 0 })
  }

  return price.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
